import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef, useRef, useState, useCallback, Fragment } from "react";
import { Field } from "../private/Field/Field.mjs";
import { Box } from "../Box/Box.mjs";
import "../Text/TextContext.mjs";
import "../Heading/HeadingContext.mjs";
import "../../css/lineHeightContainer.css.mjs";
import "../../css/reset/reset.css.mjs";
import "../../css/atoms/sprinkles.css.mjs";
import "../../hooks/useIcon/icon.css.mjs";
import "../../css/typography.css.mjs";
import { IconVisibility } from "../icons/IconVisibility/IconVisibility.mjs";
import { IconVisibilityOff } from "../icons/IconVisibilityOff/IconVisibilityOff.mjs";
import { FieldButtonIcon } from "../private/FieldButtonIcon/FieldButtonIcon.mjs";
const PasswordField = forwardRef(
  ({
    value,
    onChange,
    onBlur,
    onFocus,
    placeholder,
    disabled,
    onVisibilityToggle,
    visibilityToggleLabel = "Toggle password visibility",
    id,
    ...restProps
  }, forwardedRef) => {
    const defaultRef = useRef(null);
    const inputRef = forwardedRef || defaultRef;
    const [visible, setVisibile] = useState(false);
    const visibilityHandler = useCallback(
      (event) => {
        if (event.button !== 0) {
          return;
        }
        const newState = !visible;
        setVisibile(newState);
        if (typeof onVisibilityToggle === "function") {
          onVisibilityToggle(newState);
        }
        if (inputRef && typeof inputRef === "object" && inputRef.current) {
          inputRef.current.focus();
        }
      },
      [visible, onVisibilityToggle, inputRef]
    );
    return /* @__PURE__ */ jsx(
      Field,
      {
        ...restProps,
        id,
        value,
        icon: void 0,
        prefix: void 0,
        labelId: void 0,
        disabled,
        secondaryMessage: null,
        alwaysShowSecondaryIcon: !disabled,
        secondaryIcon: disabled ? null : /* @__PURE__ */ jsx(
          FieldButtonIcon,
          {
            id: `${id}-toggle`,
            label: visibilityToggleLabel,
            onMouseDown: visibilityHandler,
            icon: visible ? /* @__PURE__ */ jsx(IconVisibilityOff, {}) : /* @__PURE__ */ jsx(IconVisibility, {})
          }
        ),
        children: (overlays, fieldProps, _, secondaryIcon) => /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(
            Box,
            {
              component: "input",
              type: visible ? "text" : "password",
              value,
              onChange,
              onFocus,
              onBlur,
              placeholder: !disabled ? placeholder : void 0,
              ...fieldProps,
              ref: inputRef
            }
          ),
          overlays,
          secondaryIcon
        ] })
      }
    );
  }
);
PasswordField.displayName = "PasswordField";
export {
  PasswordField
};
